import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card } from 'react-daisyui';
import { BarChart, Bar, XAxis, ResponsiveContainer, Cell, Tooltip } from 'recharts';

const TransactionHistoryChart = () => {
  const [chartData, setChartData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://berachain-v2-blacknodes-el-api.blacknodes.net/api/v2/stats/charts/transactions');
        const lastSevenDays = response.data.chart_data.slice(0, 7);
        setChartData(lastSevenDays.map(item => ({
          date: item.date.slice(5).replace('-', '/'),
          transactions: item.tx_count
        })));
      } catch (error) {
        console.error('Error fetching transaction data:', error);
      }
    };

    fetchData();
  }, []);

  const handleMouseEnter = (_, index) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(null);
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-gray-800 p-2 rounded text-white">
          <p>{`${payload[0].value.toLocaleString()} transactions`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="shadow-[0px_20px_207px_10px_rgba(38,_126,_218,_0.93)]">
      <Card.Body>
        <div className="flex justify-between items-center mb-4">
          <Card.Title tag="h2" className="text-lg font-semibold text-white">Transaction History Last 7 Days</Card.Title>
          <div className="bg-gray-800 rounded-full p-2">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
            </svg>
          </div>
        </div>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={chartData} barSize={30}>
            <XAxis 
              dataKey="date" 
              axisLine={false} 
              tickLine={false} 
              tick={{ fill: '#6B7280', fontSize: 12 }}
              dy={10}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar 
              dataKey="transactions" 
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {chartData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={index === activeIndex ? '#F97316' : '#374151'}
                  stroke={index === activeIndex ? '#F97316' : '#4B5563'}
                  strokeWidth={1}
                  radius={[4, 4, 0, 0]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Card.Body>
    </Card>
  );
};

export default TransactionHistoryChart;